<template>
    <div class="mb-3">
        <div class="card shadow">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                    <i class="fas fa-info-circle text-muted"
                       style=""
                       data-toggle="tooltip"
                       data-placement="top"
                       :title="$info[info]"
                       v-if="info"></i>
                    {{ title }}
                </h6>
            </div>
            <div class="card-body">

                <pharmacy-filter-module v-if="pharmacies" :mode="pharmaciesMode" :coop-split="pharmaciesCoopSplit" :options="options" :dto="config"></pharmacy-filter-module>

                <fieldset class="border px-3 mb-3" v-if="pzn">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['filter.pzn']"></i>
                        PZN
                    </legend>

                    <div class="form-group">
                        <label>Liste hochladen</label>
                        <input type="file" class="form-control-file" accept=".xlsx,.xls" @change="pznUpload"
                               ref="pznFile">
                        <div v-if="pznErrors" class="text-danger">
                            <ul>
                                <li v-for="error in pznErrors">
                                    <span :title="JSON.stringify(error.row)">Zeile {{ error.index + 1}}:</span>
                                    {{ error.message }}
                                </li>
                            </ul>
                        </div>
                        <div class="mt-1">
                            <a href="/files/Vorlage_PZN.xlsx">
                                <small>
                                    <i class="fas fa-fw fa-download"></i>
                                    Download Vorlage
                                </small>
                            </a>
                            <a href="#" @click.prevent="addPzn">
                                <small>
                                    <i class="fas fa-fw fa-user-edit"></i>
                                    PZN hinzufügen
                                </small>
                            </a>
                            <a href="#" @click.prevent="pznListSelectVisible = true" v-if="!pznListSelectVisible">
                                <small>
                                    <i class="fas fa-fw fa-user-edit"></i>
                                    Liste hinzufügen
                                </small>
                            </a>
                        </div>

                        <div class="mt-1" v-if="pznListSelectVisible">
                            <div v-if="!pznLists.length">Noch keine Listen vorhanden!</div>
                            <button type="button"
                                    class="btn btn-sm btn-primary mr-1"
                                    v-for="list in pznLists"
                                    v-show="!config.pznLists.includes(list.id)"
                                    @click="addFromPznList(list.id)">
                                {{ list.title }} ({{ list.config.content.length }})
                            </button>
                            <button type="button"
                                    class="btn btn-sm btn-primary"
                                    @click="pznListSelectVisible = false">
                                Abbrechen
                            </button>
                        </div>
                    </div>

                    <div class="mb-3">
                        <div v-if="config.pzn.length || config.pznLists.length">
                            {{ config.pzn.length }} PZN ausgewählt
                            <a href="#" @click.prevent="pznsVisible = !pznsVisible">
                                <i class="fas fa-fw" :class="{'fa-eye': !pznsVisible, 'fa-eye-slash': pznsVisible}"></i>
                            </a>
                            <table class="table table-sm table-bordered mt-2 mb-0" v-if="pznsVisible">
                                <thead>
                                <tr>
                                    <th>PZN</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="pzn in config.pzn">
                                    <td>{{ pzn }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <br>
                            <template v-if="config.pznLists.length">
                                {{ config.pznLists.length }} Listen ausgewählt
                                (
                                <template v-for="list in selectedPznLists">
                                    <a :href="'/lists/' + list.id + '/edit'" target="_blank">
                                        {{ list.title }}
                                    </a>
                                </template>
                                )
                                <br>
                            </template>
                            <small>
                                <a href="#" @click.prevent="config.pzn = []; config.pznLists = [];">Leeren</a>
                                <template v-if="pznFillEmpty">
                                    |
                                    <input type="checkbox" :id="uuid + '-pzn-fill'" v-model="config.pznFillEmpty">
                                    <label :for="uuid + '-pzn-fill'">
                                        PZN ohne Ergebnisse anzeigen
                                    </label>
                                </template>
                            </small>
                        </div>
                        <div v-else class="text-muted">
                            Noch keine PZN ausgewählt
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3" v-if="pznGroups">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['filter.pznGroups']"></i>
                        PZN Gruppen
                    </legend>

                    <div class="form-group">
                        <label>Liste hochladen</label>
                        <input type="file" class="form-control-file" accept=".xlsx,.xls" @change="pznGroupsUpload"
                               ref="pznGroupsFile">
                        <div v-if="pznGroupsErrors" class="text-danger">
                            <ul>
                                <li v-for="error in pznGroupsErrors">
                                    <span :title="JSON.stringify(error.row)">Zeile {{ error.index + 1}}:</span>
                                    {{ error.message }}
                                </li>
                            </ul>
                        </div>
                        <div class="mt-1">
                            <a href="/files/Vorlage_PZN_Gruppen.xlsx">
                                <small>
                                    <i class="fas fa-fw fa-download"></i>
                                    Download Vorlage
                                </small>
                            </a>
                            <a href="#" @click.prevent="pznGroupsListSelectVisible = true"
                               v-if="!pznGroupsListSelectVisible">
                                <small>
                                    <i class="fas fa-fw fa-user-edit"></i>
                                    Liste hinzufügen
                                </small>
                            </a>
                        </div>

                        <div class="mt-1" v-if="pznGroupsListSelectVisible">
                            <div v-if="!pznGroupsLists.length">Noch keine Listen vorhanden!</div>
                            <button type="button"
                                    class="btn btn-sm btn-primary mr-1"
                                    v-for="list in pznGroupsLists"
                                    v-show="!config.pznGroupsLists.includes(list.id)"
                                    @click="addFromPznGroupsList(list.id)">
                                {{ list.title }} ({{ list.config.content.length }})
                            </button>
                            <button type="button"
                                    class="btn btn-sm btn-primary"
                                    @click="pznGroupsListSelectVisible = false">
                                Abbrechen
                            </button>
                        </div>
                    </div>

                    <div class="mb-3">
                        <div v-if="Object.keys(config.pznGroups).length || config.pznGroupsLists.length">
                            {{ Object.keys(config.pznGroups).length }} PZN Gruppen ausgewählt
                            <br>
                            <template v-if="config.pznGroupsLists.length">
                                {{ config.pznGroupsLists.length }} Listen ausgewählt
                                (
                                <template v-for="list in selectedPznGroupsLists">
                                    <a :href="'/lists/' + list.id + '/edit'" target="_blank">
                                        {{ list.title }}
                                    </a>
                                </template>
                                )
                                <br>
                            </template>
                            <small>
                                <a href="#"
                                   @click.prevent="config.pznGroups = {}; config.pznGroupsLists = [];">Leeren</a>
                            </small>
                        </div>
                        <div v-else class="text-muted">
                            Noch keine PZN Gruppen ausgewählt
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3" v-if="showOtherFilters">
                    <legend class="w-auto">Weitere Filter</legend>

                    <div class="form-group" v-if="wholesalers">
                        <label>
                            Großhändler
                        </label>
                        <custom-select v-model="config.wholesalerIds"
                                       :settings="wholesalerSettings"
                                       :options="wholesalerOptions"/>
                        <small class="text-muted">Wenn aktiviert, wird Sell Out nicht mehr berechnet bzw. auf Sell In umgeschaltet!</small>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['filter.abgaberegelung']"></i>
                            Abgaberegelung
                        </label>
                        <select class="form-control" v-model="config.abgaberegelung">
                            <option value="all">Alle</option>
                            <option value="rx-full">RX Gesamt</option>
                            <option value="rx-no-high">RX ohne Hochpreiser</option>
                            <option value="rx-only-high">RX nur Hochpreiser</option>
                            <option value="nonrx-full">Non RX Gesamt</option>
                            <option value="nonrx-no-free">Non RX ohne Freiwahl</option>
                            <option value="nonrx-only-free">Non RX nur Freiwahl</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['filter.anbieter']"></i>
                            Anbieter
                        </label>
                        <custom-select v-model="config.anbieter"
                                       :settings="anbieterSettings"/>
                        <div v-if="anbieterMode">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" :name="uuid + 'anbieterMode'"
                                       :id="uuid + 'anbieterModeInklusiv'"
                                       value="inclusive"
                                       v-model="config.anbieterMode">
                                <label class="form-check-label" :for="uuid + 'anbieterModeInklusiv'">
                                    Inklusiv
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" :name="uuid + 'anbieterMode'"
                                       :id="uuid + 'anbieterModeExklusiv'"
                                       value="exclusive"
                                       v-model="config.anbieterMode">
                                <label class="form-check-label" :for="uuid + 'anbieterModeExklusiv'">
                                    Exklusiv
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group" v-if="sellInModeSwitch">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellIn.modeSwitch']"></i>
                            Überweiser Zuordnung (Sell-In Blöcke)
                        </label>
                        <select class="form-control" v-model="config.sellInModeSwitch">
                            <option :value="true">Anbieter</option>
                            <option :value="false">Großhandel</option>
                        </select>
                    </div>

                    <div class="form-group" v-if="warengruppen">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['filter.warengruppen']"></i>
                            Warengruppen
                        </label>
                        <custom-select v-model="config.warengruppen"
                                       :settings="warengruppenSettings"/>
                    </div>

                    <div class="form-group" v-if="wirkstoffe">
                        <div class="row">
                            <div class="col-auto">
                                <label>
                                    <i class="fas fa-info-circle text-muted"
                                       style=""
                                       data-toggle="tooltip"
                                       data-placement="top"
                                       :title="$info['filter.wirkstoffe']"></i>
                                    Wirkstoffe
                                </label>
                            </div>
                            <div class="col text-right" v-if="warengruppen && warengruppenWirkstoffeOr">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :id="uuid + '-wirk-war'"
                                           v-model="config.warengruppenWirkstoffeOr">
                                    <label class="form-check-label" :for="uuid + '-wirk-war'">
                                        Verknüpfung mit Warengruppen
                                    </label>
                                </div>
                            </div>
                        </div>
                        <custom-select v-model="config.wirkstoffe"
                                       :settings="wirkstoffeSettings"/>
                    </div>

                    <div class="form-group" v-if="dar">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['filter.dar']"></i>
                            Darreichungsformen
                        </label>
                        <custom-select v-model="config.dar"
                                       :settings="darSettings"/>
                    </div>

                    <div class="form-group" v-if="menge">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['filter.groesse']"></i>
                            Größe
                        </label>
                        <div class="row">
                            <div class="col">
                                <select class="form-control" v-model="config.einheit">
                                    <option value="all">Alle</option>
                                    <option :value="einheit" v-for="einheit in einheiten">{{ einheit }}</option>
                                </select>
                            </div>
                            <div class="col" v-if="config.einheit !== 'all'">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Menge</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="100" v-model="config.menge">
                                </div>
                            </div>
                            <div class="col" v-if="config.einheit !== 'all'">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Varianz %</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="20"
                                           v-model="config.mengeVarianz">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group" v-if="umsatz">
                        <label><b>Umsatzfilter</b></label>
                        <div class="row">
                            <div class="col">
                                <select class="form-control" v-model="config.salesMode">
                                    <option value="none">Deaktiviert</option>
                                    <option value="sell-in">Sell-In</option>
                                    <option value="sell-out">Sell-Out</option>
                                </select>
                            </div>
                            <div class="col" v-if="config.salesMode !== 'none'">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Min Euro</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.salesMin">
                                </div>
                            </div>
                            <div class="col" v-if="config.salesMode !== 'none'">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Max Euro</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.salesMax">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group" v-if="reimport">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['filter.reimport']"></i>
                            Re-Import
                        </label>
                        <select class="form-control" v-model="config.reimport">
                            <option value="all">Alle</option>
                            <option value="yes">Nur Re-Import</option>
                            <option value="no">Kein Re-Import</option>
                        </select>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>

import PharmacyFilterModule from "./PharmacyFilterModule";

export default {
    components: {PharmacyFilterModule},
    props: {
        title: {
            type: String,
            default: 'Filter'
        },
        info: {
            type: String,
        },
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        showOtherFilters: {
            type: Boolean,
            default: true
        },
        pharmacies: {
            type: Boolean,
            default: true
        },
        pharmaciesMode: {
            type: Boolean,
            default: false
        },
        pharmaciesCoopSplit: {
            type: Boolean,
            default: false
        },
        wholesalers: {
            type: Boolean,
            default: false
        },
        pzn: {
            type: Boolean,
            default: true
        },
        pznFillEmpty: {
            type: Boolean,
            default: true
        },
        pznGroups: {
            type: Boolean,
            default: false
        },
        warengruppen: {
            type: Boolean,
            default: false
        },
        warengruppenWirkstoffeOr: {
            type: Boolean,
            default: true
        },
        anbieterMode: {
            type: Boolean,
            default: false
        },
        sellInModeSwitch: {
            type: Boolean,
            default: false
        },
        dar: {
            type: Boolean,
            default: false
        },
        menge: {
            type: Boolean,
            default: false
        },
        wirkstoffe: {
            type: Boolean,
            default: false
        },
        umsatz: {
            type: Boolean,
            default: false
        },
        reimport: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            uuid: this.$uuid.v4(),
            config: this.dto,
            pznsVisible: false,
            pznListSelectVisible: false,
            pznGroupsListSelectVisible: false,
            pznErrors: null,
            pznGroupsErrors: null,
            wholesalerSettings: {
                multiple: true,
                tags: false,
            },
            anbieterSettings: {
                ajax: {
                    url: '/select/anbieter',
                    dataType: 'json'
                },
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
            warengruppenSettings: {
                ajax: {
                    url: '/select/warengruppen',
                    dataType: 'json'
                },
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
            darSettings: {
                ajax: {
                    url: '/select/dar',
                    dataType: 'json'
                },
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
            wirkstoffeSettings: {
                ajax: {
                    url: '/select/wirkstoffe',
                    dataType: 'json'
                },
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
            einheitSettings: {
                ajax: {
                    url: '/select/einheit',
                    dataType: 'json'
                },
                multiple: false,
                tags: false,
            }
        };
    },
    methods: {
        pznUpload() {
            this.pznErrors = null;
            const file = this.$refs.pznFile.files[0];
            const formData = new FormData();
            formData.append('file', file);
            const headers = {'Content-Type': 'multipart/form-data'};
            axios.post('/files/pzn', formData, {headers}).then((res) => {
                this.config.pzn = res.data;
            }).catch((error) => {
                const importError = error.response.data.import_errors || false;
                if (importError) {
                    this.pznErrors = error.response.data.errors;
                } else {
                    console.log(error);
                    alert("Unbekannter Fehler");
                }

            }).finally(() => {
                this.$refs.pznFile.value = '';
            });
        },
        pznGroupsUpload() {
            this.pznGroupsErrors = null;
            const file = this.$refs.pznGroupsFile.files[0];
            const formData = new FormData();
            formData.append('file', file);
            const headers = {'Content-Type': 'multipart/form-data'};
            axios.post('/files/pzn-groups', formData, {headers}).then((res) => {
                this.config.pznGroups = res.data;
            }).catch((error) => {
                const importError = error.response.data.import_errors || false;
                if (importError) {
                    this.pznGroupsErrors = error.response.data.errors;
                } else {
                    console.log(error);
                    alert("Unbekannter Fehler");
                }

            }).finally(() => {
                this.$refs.pznGroupsFile.value = '';
            });
        },
        addPzn() {
            const newPzns = window.prompt('PZN');
            if (newPzns) {
                newPzns.split(',').forEach((newPzn) => {
                    if (!this.config.pzn.some(pzn => parseInt(pzn) === parseInt(newPzn))) {
                        this.config.pzn.push(newPzn);
                    }
                });
            }
        },
        addFromPznList(listId) {
            if (!this.config.pznLists.includes(listId)) {
                this.config.pznLists.push(listId);
            }
            this.pznListSelectVisible = false;
        },
        addFromPznGroupsList(listId) {
            if (!this.config.pznGroupsLists.includes(listId)) {
                this.config.pznGroupsLists.push(listId);
            }
            this.pznGroupsListSelectVisible = false;
        }
    },
    computed: {
        einheiten() {
            return [
                'cm',
                'm',
                'μg',
                'mg',
                'g',
                'kg',
                'ml',
                'l',
                'P',
                'Sp',
                'Fl',
                'St',
            ];
        },
        pznLists() {
            return (this.options.lists['pzn'] || []);
        },
        selectedPznLists() {
            return this.pznLists.filter((list) => {
                return this.config.pznLists.includes(list.id);
            });
        },
        pznGroupsLists() {
            return (this.options.lists['pzn-groups'] || []);
        },
        selectedPznGroupsLists() {
            return this.pznGroupsLists.filter((list) => {
                return this.config.pznGroupsLists.includes(list.id);
            });
        },
        wholesalerOptions() {
            return this.options.wholesalers.map((wholesaler) => {
                let title = wholesaler.name;
                if (wholesaler.short) {
                    title += ' (' + wholesaler.short + ')';
                }

                return {
                    id: wholesaler.id,
                    text: title
                };
            });
        }
    }
}
</script>
